export default {
  assignedLoads: 'بارهای تخصیص یافته',
  currentLoads: 'بارهای جاری',
  endedLoads: 'سفارشات پایان یافته',
  origin: 'مبدا',
  destination: 'مقصد',
  multiDestination: 'چند‌مقصدی',
  loadDetail: 'جزئیات بار',
  loading: 'بارگیری',
  discharge: 'تخلیه',
  received: 'دریافت',
  delivered: 'تحویل',
  pendingDelivery: 'در انتظار تحویل',
  successfulDelivery: 'تحویل موفق',
  failedDelivery: 'تحویل ناموفق',
  showResolvedDestinations: 'نمایش مقصدهای تعیین تکلیف شده',
  cityAndProvince: 'شهر / استان',
  destination1: 'تحویل به مقصد اول',
  destination2: 'تحویل به مقصد دوم',
  destination3: 'تحویل به مقصد سوم',
  destination4: 'تحویل به مقصد چهارم',
  destination5: 'تحویل به مقصد پنجم',
  destination6: 'تحویل به مقصد ششم',
  destination7: 'تحویل به مقصد هفتم',
  destination8: 'تحویل به مقصد هشتم',
  destination9: 'تحویل به مقصد نهم',
  destination10: 'تحویل به مقصد دهم',
  destination11: 'تحویل به مقصد یازدهم',
  destination12: 'تحویل به مقصد دوازدهم',
  destination13: 'تحویل به مقصد سیزدهم',
  destination14: 'تحویل به مقصد چهاردهم',
  destination15: 'تحویل به مقصد پانزدهم',
  destination16: 'تحویل به مقصد شانزدهم',
  destination17: 'تحویل به مقصد هفدهم',
  destination18: 'تحویل به مقصد هجدهم',
  destination19: 'تحویل به مقصد نوزدهم',
  destination20: 'تحویل به مقصد بیستم',
  destination21: 'تحویل به مقصد بیست و یکم',
  destination22: 'تحویل به مقصد بیست و دوم',
  destination23: 'تحویل به مقصد بیست و سوم',
  destination24: 'تحویل به مقصد بیست و چهارم',
  destination25: 'تحویل به مقصد بیست و پنجم',
  destination26: 'تحویل به مقصد بیست و ششم',
  destination27: 'تحویل به مقصد بیست و هفتم',
  destination28: 'تحویل به مقصد بیست و هشتم',
  destination29: 'تحویل به مقصد بیست و نهم',
  destination30: 'تحویل به مقصد سی‌ام',
  destination31: 'تحویل به مقصد سی و یکم',
  destination32: 'تحویل به مقصد سی و دوم',
  destination33: 'تحویل به مقصد سی و سوم',
  destination34: 'تحویل به مقصد سی و چهارم',
  destination35: 'تحویل به مقصد سی و پنجم',
  destination36: 'تحویل به مقصد سی و ششم',
  destination37: 'تحویل به مقصد سی و هفتم',
  destination38: 'تحویل به مقصد سی و هشتم',
  destination39: 'تحویل به مقصد سی و نهم',
  destination40: 'تحویل به مقصد چهلم',
  destination41: 'تحویل به مقصد چهل و یکم',
  destination42: 'تحویل به مقصد چهل و دوم',
  destination43: 'تحویل به مقصد چهل و سوم',
  destination44: 'تحویل به مقصد چهل و چهارم',
  destination45: 'تحویل به مقصد چهل و پنجم',
  destination46: 'تحویل به مقصد چهل و ششم',
  destination47: 'تحویل به مقصد چهل و هفتم',
  destination48: 'تحویل به مقصد چهل و هشتم',
  destination49: 'تحویل به مقصد چهل و نهم',
  destination50: 'تحویل به مقصد پنجاهم',
  destination51: 'تحویل به مقصد پنجاه و یکم',
  destination52: 'تحویل به مقصد پنجاه و دوم',
  destination53: 'تحویل به مقصد پنجاه و سوم',
  destination54: 'تحویل به مقصد پنجاه و چهارم',
  destination55: 'تحویل به مقصد پنجاه و پنجم',
  destination56: 'تحویل به مقصد پنجاه و ششم',
  destination57: 'تحویل به مقصد پنجاه و هفتم',
  destination58: 'تحویل به مقصد پنجاه و هشتم',
  destination59: 'تحویل به مقصد پنجاه و نهم',
  destination60: 'تحویل به مقصد شصتم',
  destination61: 'تحویل به مقصد شصت و یکم',
  destination62: 'تحویل به مقصد شصت و دوم',
  destination63: 'تحویل به مقصد شصت و سوم',
  destination64: 'تحویل به مقصد شصت و چهارم',
  destination65: 'تحویل به مقصد شصت و پنجم',
  destination66: 'تحویل به مقصد شصت و ششم',
  destination67: 'تحویل به مقصد شصت و هفتم',
  destination68: 'تحویل به مقصد شصت و هشتم',
  destination69: 'تحویل به مقصد شصت و نهم',
  destination70: 'تحویل به مقصد هفتادم',
  destination71: 'تحویل به مقصد هفتاد و یکم',
  destination72: 'تحویل به مقصد هفتاد و دوم',
  destination73: 'تحویل به مقصد هفتاد و سوم',
  destination74: 'تحویل به مقصد هفتاد و چهارم',
  destination75: 'تحویل به مقصد هفتاد و پنجم',
  destination76: 'تحویل به مقصد هفتاد و ششم',
  destination77: 'تحویل به مقصد هفتاد و هفتم',
  destination78: 'تحویل به مقصد هفتاد و هشتم',
  destination79: 'تحویل به مقصد هفتاد و نهم',
  destination80: 'تحویل به مقصد هشتادم',
  destination81: 'تحویل به مقصد هشتاد و یکم',
  destination82: 'تحویل به مقصد هشتاد و دوم',
  destination83: 'تحویل به مقصد هشتاد و سوم',
  destination84: 'تحویل به مقصد هشتاد و چهارم',
  destination85: 'تحویل به مقصد هشتاد و پنجم',
  destination86: 'تحویل به مقصد هشتاد و ششم',
  destination87: 'تحویل به مقصد هشتاد و هفتم',
  destination88: 'تحویل به مقصد هشتاد و هشتم',
  destination89: 'تحویل به مقصد هشتاد و نهم',
  destination90: 'تحویل به مقصد نودم',
  destination91: 'تحویل به مقصد نود و یکم',
  destination92: 'تحویل به مقصد نود و دوم',
  destination93: 'تحویل به مقصد نود و سوم',
  destination94: 'تحویل به مقصد نود و چهارم',
  destination95: 'تحویل به مقصد نود و پنجم',
  destination96: 'تحویل به مقصد نود و ششم',
  destination97: 'تحویل به مقصد نود و هفتم',
  destination98: 'تحویل به مقصد نود و هشتم',
  destination99: 'تحویل به مقصد نود و نهم',
  destination100: 'تحویل به مقصد صدم',
  finalDestination: 'مقصد نهایی',
  stepActions: {
    reachOrigin: 'به مبدا رسیدم',
    loading: 'بارگیری کردم',
    received: 'تحویل گرفتم',
    reachMiddlePoint: 'به {middlePoint} رسیدم',
    reachDestination: 'تحویل مرسوله',
    reachDestination1: 'تحویل مرسوله اول',
    reachDestination2: 'تحویل مرسوله دوم',
    reachDestination3: 'تحویل مرسوله سوم',
    reachDestination4: 'تحویل مرسوله چهارم',
    reachDestination5: 'تحویل مرسوله پنجم',
    reachDestination6: 'تحویل مرسوله ششم',
    reachDestination7: 'تحویل مرسوله هفتم',
    reachDestination8: 'تحویل مرسوله هشتم',
    reachDestination9: 'تحویل مرسوله نهم',
    reachDestination10: 'تحویل مرسوله دهم',
    reachDestination11: 'تحویل مرسوله یازدهم',
    reachDestination12: 'تحویل مرسوله دوازدهم',
    reachDestination13: 'تحویل مرسوله سیزدهم',
    reachDestination14: 'تحویل مرسوله چهاردهم',
    reachDestination15: 'تحویل مرسوله پانزدهم',
    reachDestination16: 'تحویل مرسوله شانزدهم',
    reachDestination17: 'تحویل مرسوله هفدهم',
    reachDestination18: 'تحویل مرسوله هجدهم',
    reachDestination19: 'تحویل مرسوله نوزدهم',
    reachDestination20: 'تحویل مرسوله بیستم',
    reachDestination21: 'تحویل مرسوله بیست و یکم',
    reachDestination22: 'تحویل مرسوله بیست و دوم',
    reachDestination23: 'تحویل مرسوله بیست و سوم',
    reachDestination24: 'تحویل مرسوله بیست و چهارم',
    reachDestination25: 'تحویل مرسوله بیست و پنجم',
    reachDestination26: 'تحویل مرسوله بیست و ششم',
    reachDestination27: 'تحویل مرسوله بیست و هفتم',
    reachDestination28: 'تحویل مرسوله بیست و هشتم',
    reachDestination29: 'تحویل مرسوله بیست و نهم',
    reachDestination30: 'تحویل مرسوله سی‌ام',
    reachDestination31: 'تحویل مرسوله سی و یکم',
    reachDestination32: 'تحویل مرسوله سی و دوم',
    reachDestination33: 'تحویل مرسوله سی و سوم',
    reachDestination34: 'تحویل مرسوله سی و چهارم',
    reachDestination35: 'تحویل مرسوله سی و پنجم',
    reachDestination36: 'تحویل مرسوله سی و ششم',
    reachDestination37: 'تحویل مرسوله سی و هفتم',
    reachDestination38: 'تحویل مرسوله سی و هشتم',
    reachDestination39: 'تحویل مرسوله سی و نهم',
    reachDestination40: 'تحویل مرسوله چهلم',
    reachDestination41: 'تحویل مرسوله چهل و یکم',
    reachDestination42: 'تحویل مرسوله چهل و دوم',
    reachDestination43: 'تحویل مرسوله چهل و سوم',
    reachDestination44: 'تحویل مرسوله چهل و چهارم',
    reachDestination45: 'تحویل مرسوله چهل و پنجم',
    reachDestination46: 'تحویل مرسوله چهل و ششم',
    reachDestination47: 'تحویل مرسوله چهل و هفتم',
    reachDestination48: 'تحویل مرسوله چهل و هشتم',
    reachDestination49: 'تحویل مرسوله چهل و نهم',
    reachDestination50: 'تحویل مرسوله پنجاهم',
    reachDestination51: 'تحویل مرسوله پنجاه و یکم',
    reachDestination52: 'تحویل مرسوله پنجاه و دوم',
    reachDestination53: 'تحویل مرسوله پنجاه و سوم',
    reachDestination54: 'تحویل مرسوله پنجاه و چهارم',
    reachDestination55: 'تحویل مرسوله پنجاه و پنجم',
    reachDestination56: 'تحویل مرسوله پنجاه و ششم',
    reachDestination57: 'تحویل مرسوله پنجاه و هفتم',
    reachDestination58: 'تحویل مرسوله پنجاه و هشتم',
    reachDestination59: 'تحویل مرسوله پنجاه و نهم',
    reachDestination60: 'تحویل مرسوله شصتم',
    reachDestination61: 'تحویل مرسوله شصت و یکم',
    reachDestination62: 'تحویل مرسوله شصت و دوم',
    reachDestination63: 'تحویل مرسوله شصت و سوم',
    reachDestination64: 'تحویل مرسوله شصت و چهارم',
    reachDestination65: 'تحویل مرسوله شصت و پنجم',
    reachDestination66: 'تحویل مرسوله شصت و ششم',
    reachDestination67: 'تحویل مرسوله شصت و هفتم',
    reachDestination68: 'تحویل مرسوله شصت و هشتم',
    reachDestination69: 'تحویل مرسوله شصت و نهم',
    reachDestination70: 'تحویل مرسوله هفتادم',
    reachDestination71: 'تحویل مرسوله هفتاد و یکم',
    reachDestination72: 'تحویل مرسوله هفتاد و دوم',
    reachDestination73: 'تحویل مرسوله هفتاد و سوم',
    reachDestination74: 'تحویل مرسوله هفتاد و چهارم',
    reachDestination75: 'تحویل مرسوله هفتاد و پنجم',
    reachDestination76: 'تحویل مرسوله هفتاد و ششم',
    reachDestination77: 'تحویل مرسوله هفتاد و هفتم',
    reachDestination78: 'تحویل مرسوله هفتاد و هشتم',
    reachDestination79: 'تحویل مرسوله هفتاد و نهم',
    reachDestination80: 'تحویل مرسوله هشتادم',
    reachDestination81: 'تحویل مرسوله هشتاد و یکم',
    reachDestination82: 'تحویل مرسوله هشتاد و دوم',
    reachDestination83: 'تحویل مرسوله هشتاد و سوم',
    reachDestination84: 'تحویل مرسوله هشتاد و چهارم',
    reachDestination85: 'تحویل مرسوله هشتاد و پنجم',
    reachDestination86: 'تحویل مرسوله هشتاد و ششم',
    reachDestination87: 'تحویل مرسوله هشتاد و هفتم',
    reachDestination88: 'تحویل مرسوله هشتاد و هشتم',
    reachDestination89: 'تحویل مرسوله هشتاد و نهم',
    reachDestination90: 'تحویل مرسوله نودم',
    reachDestination91: 'تحویل مرسوله نود و یکم',
    reachDestination92: 'تحویل مرسوله نود و دوم',
    reachDestination93: 'تحویل مرسوله نود و سوم',
    reachDestination94: 'تحویل مرسوله نود و چهارم',
    reachDestination95: 'تحویل مرسوله نود و پنجم',
    reachDestination96: 'تحویل مرسوله نود و ششم',
    reachDestination97: 'تحویل مرسوله نود و هفتم',
    reachDestination98: 'تحویل مرسوله نود و هشتم',
    reachDestination99: 'تحویل مرسوله نود و نهم',
    reachDestination100: 'تحویل مرسوله صدم',
    reachFinalDestination: 'تحویل مرسوله نهایی',
    discharge: 'اتمام سفر',
    delivered: 'اتمام سفر'
  },
  carType: 'نوع خودرو',
  loaderType: 'نوع بارگیر',
  numberOfWorkers: 'تعداد کارگر',
  trajectory: 'خط سیر',
  noAllocation: 'عدم تخصیص',
  generalInfo: 'اطلاعات کلی',
  loadTime: 'زمان بارگیری',
  dischargeTime: 'تاریخ تخلیه',
  estimatedTimeFromOriginToDestination: 'زمان تقریبی مبدا تا مقصد',
  distanceFromOriginToDestination: 'فاصله مبدا تا مقصد',
  justBillOfLadingInfo: 'اطلاعات فقط صدور بارنامه',
  driverOfferAmount: 'مبلغ پیشنهادی راننده',
  driverName: 'نام راننده',
  driverLastName: 'نام خانوادگی راننده',
  driverNationalId: 'کد ملی راننده',
  smartFleetCode: 'کد هوشمند ناوگان',
  plate: 'پلاک',
  originAndDestinationInfo: 'اطلاعات مبدا و مقصد',
  deliverer: 'تحویل دهنده',
  transferee: 'تحویل گیرنده',
  floor: 'طبقه',
  unit: 'واحد',
  distanceFromDoorToCar: 'فاصله درب تا خودرو',
  loadType: 'نوع بار',
  loadSpecifications: 'مشخصات بار',
  package: 'بسته بندی',
  packageType: 'نوع بسته بندی',
  weight: 'وزن',
  loadMonetaryValue: 'ارزش بار',
  monetaryValue: 'ارزش',
  totalOrderAmount: 'مبلغ کل سفارش',
  acceptOffer: 'قبول پیشنهاد',
  pricing: 'قیمت دهی',
  deliveryCode: 'کد تحویل',
  dischargeDescription: 'برای تخلیه بار، کد تحویل مشتری را وارد کنید',
  sendDeliveryCodeToCustomer: 'ارسال کد تحویل برای مشتری',
  showMiddlePoints: 'نمایش مقاصد میانی',
  hideMiddlePoints: 'عدم نمایش مقاصد میانی',
  yourOffer: 'پیشنهاد شما',
  totalAmount: 'مبلغ نهایی',
  loadId: 'شناسه بار',
  extractPoint: 'محل استخراج',
  dischargePoint: 'محل تخلیه',
  dischargeStartTime: 'زمان شروع تخلیه',
  dischargeEndTime: 'زمان پایان تخلیه',
  contractType: 'نوع قرارداد',
  shift: 'شیفت',
  reason: 'دلیل',
  unsuccessfulDestinations: 'مقاصد ناموفق',
  destinationOrderId: 'شماره سفارش: {orderId}',
  customerNameDestination: 'نام مشتری: {name}',
  customerPhoneNumberDestination: 'شماره تماس مشتری: {mobile}',
  failedReasonDestination: 'دلیل عدم تحویل: {reason}',
  addressDestination: 'آدرس: {address}'
}
